<svg class="lui-icon" [style.width]="size" [style.height]="size">
  <use #iconRef />
</svg>
